import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from '../../shared/components/ErrorBoundary';
import LoadingScreen from '../../shared/components/LoadingScreen';
import { InfluencerDashboard } from './dashboard';
import { Layout } from '../Layout';
import InfluencerExplore from './explore';
import { OfferManagement } from './offer';
import InfluencerPlanner from './planner';
import InfluencerReporting from './reporting';
import InfluencerMessages from './messages';
import InfluencerInvoices from './invoices';
import { SettingsRoutes } from '../shared/routes';
import InvoiceArchive from './invoices/invoice-archive';

const BriefingDetail = lazy(() => import('./campaign/briefing'));
const InfluencerCampaigns = lazy(() => import('./campaign/index'));
const ForbiddenPage = lazy(() => import('../../authentication/403'));
const InfluencerProfile = lazy(() => import('./profile/profile-view'));
const DeclinedOffers = lazy(() => import('./declined-offers'));

export function InfluencerRoutes() {
    const { pathname } = useLocation();

    return (
        <Suspense fallback={<LoadingScreen />}>
            <ErrorBoundary key={pathname}>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/influencer/profile/:id" element={<InfluencerProfile />} />
                        <Route path="/influencer/dashboard" element={<InfluencerDashboard />} />
                        <Route path="/influencer/offers" element={<OfferManagement />} />
                        <Route path="/influencer/explore" element={<InfluencerExplore />} />
                        <Route path="/influencer/campaigns" element={<InfluencerCampaigns />} />
                        <Route path="/influencer/campaign/:id/overview" element={<BriefingDetail />} />
                        <Route path="/influencer/planner" element={<InfluencerPlanner />} />
                        <Route path="/influencer/reporting" element={<InfluencerReporting />} />
                        <Route path="/influencer/messages/:id?" element={<InfluencerMessages />} />
                        <Route path="/influencer/invoices" element={<InfluencerInvoices />} />
                        <Route path="/influencer/invoices/archive" element={<InvoiceArchive />} />
                        <Route path="/influencer/offer/declined" element={<DeclinedOffers />} />
                        <Route path="/settings/*" element={<SettingsRoutes />} />
                        <Route path="/403" element={<ForbiddenPage />} />
                    </Route>
                    {/* <Route
                        path="/impersonate/:token/:id/:isAdmin/:adminActiveFirstRoute?/:adminActiveSecondRoute?/:adminActiveThirdRoute?"
                        element={<Impersonate />}
                    /> */}
                    <Route path="/auth/login" element={<Navigate to="/influencer/dashboard" replace />} />
                    <Route path="/" element={<Navigate to="/influencer/dashboard" replace />} />
                    <Route path="*" element={<Navigate to="/influencer/dashboard" replace />} />
                </Routes>
            </ErrorBoundary>
        </Suspense>
    );
}
